export const LOCALE_ENGLISH = 'header_locale.english';
export const LOCALE_FRENCH = 'header_locale.french';
export const SIGNUP_LOGIN_ARIA_LABEL = 'signup_login.aria_label';
